export const CANDIDATES_SIGNUP_STATUS = {
  BECOME_AE: "BECOME_AE",
  ALREADY_AE: "ALREADY_AE",
  NOT_INTERESTED: "NOT_INTERESTED",
};

export const CANDIDATES_ONBOARDING_STEPS = {
  ONBOARDING_PERSONNAL_INFORMATIONS: "personal_informations",
  ONBOARDING_ADDRESS: "address",
  ONBOARDING_PICTURE: "picture",
  ONBOARDING_EXPERIENCE: "experience",
  ONBOARDING_ABOUT: "about",
  ONBOARDING_ORIGIN: "origin",
  ONBOARDING_CONTRACTS: "contract",
  ONBOARDING_QUALIFICATION: "qualification",
  ONBOARDING_QUALIFICATION_DURATION: "qualification_duration",
};

export const CANDIDATES_APPLY_ORIGINS = {
  SIGNUP: "register",
  LOGIN: "login",
  DIRECT: "direct",
};

export const CANDIDATES_OFFER_STATUS = {
  PENDING: "pending",
  APPLIED: "applied",
  SELECTED: "selected",
  HIRED: "hired",
  REFUSED: "refused",
  CANCELLED_MISSION: "cancelled_after_got_hired",
  CANCELLED_ETAB: "cancelled_by_etab",
  REVIEWABLE: "reviewable",
};

export const CANDIDATE_SHIFT_STATUS = {
  IN_PROGRESS: {
    status: "in_progress",
    label: "Job en cours",
    color: "extra-orange",
  },

  CANCELLED_BY_CANDIDATE: {
    status: "candidate_cancel",
    label: "Job annulé",
    color: "extra-dark-red",
  },
  COMING_SOON: {
    status: "coming_soon",
    label: "Job à venir",
    color: "extra-green",
  },
  CANCELLED_BY_ETAB: {
    status: "etab_cancel",
    label: "Jobs annulé par l'établissement",
    color: "extra-dark-red",
  },
};

export const CANDIDATES_APPLY_STATUS_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
};

export const CANDIDATES_GENDERS = {
  MALE: "homme",
  FEMALE: "femme",
};

export const MINIMUM_AGE = 16;
export const ORIGIN_OTHER_ID = 9;
export const ORIGIN_OTHER = "Autre";

export const CANDIDATE_UPLOAD_FILE_NAME = {
  IDENTITY: "IDENTITE",
  RIB: "RIB",
  INSEE: "INSEE",
  IDENTITY_VERSO: "IDENTITE_VERSO",
  RESIDENCE: "RESIDENCE",
  RESIDENCE_PERMIT: "RESIDENCE_PERMIT",
  RESIDENCE_PERMIT_VERSO: "RESIDENCE_PERMIT_VERSO",
};

export const IBAN_SUFFIX = {
  FR: "FR",
};

export const CANDIDATE_AE_FOLDER_STATUS = {
  STATUS_PENDING: "pending", // incomplete candidate side or a new document has add
  STATUS_PENDING_INTERNAL_VERIFICATION: "pending_internal_verification", // Candidate is waiting for the internal verification
  STATUS_VERIFIED: "verified",
  STATUS_REFUSED: "refused", // in case of internal verification failed
};

export const CANDIDATE_KYC_STATUS = {
  NON_EXISTENT: "nonexistent",
  WAITING_FOR_ACCEPTANCE: "waiting_for_acceptance",
  PENDING: "pending",
  UNVERIFIED: "unverified",
  VERIFIED: "verified",
};
export const AE_FOLDER_IDENTITY_LIST = {
  CNI: "CNI",
  PASSEPORT_UE: "PASSEPORT_UE",
  PASSEPORT_FR: "PASSEPORT_FR",
  PASSEPORT_APART_FROM_UE: "PASSEPORT_HORS_UE",
  CNI_APART_FROM_UE: "CNI_HORS_UE",
  CNIE: "CNIE",
  TEMPORARY_RESIDENCE_PERMIT: "TITRE_SEJOUR_TEMPORAIRE",
  RESIDENCE_PERMIT: "TITRE_SEJOUR",
};

export const FOLDER_TYPE = {
  AE: "ae",
};

export const PAGINATION_MAX_OFFERS_PER_PAGE = 30;

export const CANDIDATE_STORED_DATA_MAX_TTL = 2 * 60 * 1000; // 2 min in ms: max duration before stored data in vuex must be refreshed

export const SATISFACTION_STATUS = [
  { iconSelected: "fa-solid fa-face-smile", iconUnselected: "fa-regular fa-face-smile", level: 5 },
  { iconSelected: "fa-solid fa-face-meh", iconUnselected: "fa-regular fa-face-meh", level: 3 },
  { iconSelected: "fa-solid fa-face-frown", iconUnselected: "fa-regular fa-face-frown", level: 1 },
];

export const ONBOARDING_CONTRACTS = {
  CDI: {
    label: "CDI",
    icon: "📃",
  },
  SEASON: {
    label: "Saisonnier",
    icon: "☀️",
  },
  MISSION: {
    label: "Extra / Mission",
    icon: "🍃",
  },
};

export const ONBOARDING_FAMILY_QUALIFICATIONS = {
  OTHER: "Autres",
  KITCHEN: "Cuisine",
  RETAIL: "Vente/Livraison",
  BAR: "Salle/Bar",
  HOTEL: "Hôtel",
};

export const ONBOARDING_QUALIFICATIONS_DURATION = {
  NO_EXP: "Sans expérience",
  BEGINNERS: "Moins d'un an",
  INTERMEDIATE: "1 à 3 ans",
  EXPERT: "Plus de 3 ans",
};

export const CONTRACT_SLIDE_LABELS = {
  CDI: "cdi",
  SEASON: "saisonnier",
  MISSION: "extra",
};

export const HOME_CANDIDATE_COMPONENTS_TYPES = {
  WELCOME_BANNER: "welcome_banner",
  INFO_CARD: "infos_card",
  OFFERS_SLIDER: "offers_slider",
  ACTION_CARD: "action_card",
};

export const HOME_CONTRACT_TYPES = {
  TEMPORARY: "temporary",
  PERMANENT: "permanent",
};

export const HOME_CONTRACTS = {
  CDI: "CDI",
  SEASON: "Saisonnier",
  AE: "Auto-entrepreneur",
  INTERIM: "Interim",
};
